/* Greenform — metafield-driven pot selector (per-size).
   - A leading "No pot" swatch is selected by default: shows the 360 viewer at the
     base plant price and adds nothing extra to the cart.
   - Selecting a pot: shows the pot's composite (or stays on the 360 if it has none),
     adds the pot's price to the shown price, and — on Add to cart — adds the pot
     product as a second line item alongside the plant.
   Independent of product.js (which handles variant-based pots). */
(function () {
  'use strict';
  var section = document.querySelector('[data-product-section]');
  if (!section) return;
  var dataEl = section.querySelector('[data-pots]');
  var potBlock = section.querySelector('[data-pot-block]');
  var potRow = section.querySelector('[data-pot-row]');
  if (!dataEl || !potBlock || !potRow) return;

  var POTS = {};
  try { POTS = JSON.parse(dataEl.textContent) || {}; } catch (e) { return; }

  var stage    = section.querySelector('[data-stage]');
  var spinWrap = section.querySelector('[data-spin-viewer]');
  var staticImg= section.querySelector('[data-stage-static]');
  var spinCue  = section.querySelector('[data-spin-cue]');
  var viewTag  = section.querySelector('[data-view-tag]');
  var sizeRow  = section.querySelector('.size-row[data-option-group]');
  var priceEl  = section.querySelector('[data-current-price]');
  var form     = section.querySelector('[data-product-form]');
  var variantInput = section.querySelector('[data-variant-id-input]');
  var submitBtn = section.querySelector('[data-add-to-cart-btn]');

  /* null = "No pot"; otherwise { vid, price, title } for the chosen pot */
  var selectedPot = null;

  function currentSize() {
    if (sizeRow) {
      var s = sizeRow.querySelector('.selected') || sizeRow.querySelector('[data-option-value]');
      if (s) return s.getAttribute('data-option-value');
    }
    var keys = Object.keys(POTS);
    return keys.length ? keys[0] : null;
  }
  function sizeData() {
    return POTS[currentSize()] || { base: 0, pots: [] };
  }
  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  function updatePrice() {
    if (!priceEl) return;
    var base = sizeData().base || 0;
    var total = base + (selectedPot ? selectedPot.price : 0);
    priceEl.textContent = money(total);
  }

  function showComposite(url, label) {
    if (!staticImg) return;
    staticImg.src = url; staticImg.hidden = false;
    if (spinWrap) spinWrap.style.display = 'none';
    if (spinCue) spinCue.classList.add('hidden');
    if (viewTag) { viewTag.classList.remove('hidden'); viewTag.textContent = label || ''; }
    if (stage) stage.classList.remove('spinning');
  }
  function backTo360() {
    if (staticImg) staticImg.hidden = true;
    if (spinWrap) spinWrap.style.display = '';
    if (spinCue) spinCue.classList.remove('hidden');
    if (viewTag) viewTag.classList.add('hidden');
  }
  function clearSelected() {
    potRow.querySelectorAll('.swatch').forEach(function (b) { b.classList.remove('selected'); });
  }

  function renderPots() {
    var arr = sizeData().pots || [];
    potRow.innerHTML = '';
    selectedPot = null;
    if (!arr.length) { potBlock.hidden = true; updatePrice(); return; }
    potBlock.hidden = false;

    /* "No pot" — default selected, returns to the 360, no price add, no cart add */
    var noneBtn = document.createElement('button');
    noneBtn.type = 'button';
    noneBtn.className = 'swatch none selected';
    noneBtn.setAttribute('aria-label', 'No pot');
    noneBtn.title = 'No pot';
    noneBtn.setAttribute('data-pot-none', '');
    noneBtn.addEventListener('click', function () {
      clearSelected(); noneBtn.classList.add('selected');
      selectedPot = null; backTo360(); updatePrice();
    });
    potRow.appendChild(noneBtn);

    arr.forEach(function (p) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'swatch';
      b.style.background = p.swatch || '#cccccc';
      b.setAttribute('aria-label', p.title); b.title = p.title;
      b.setAttribute('data-pot-handle', p.handle);
      b.addEventListener('click', function () {
        clearSelected(); b.classList.add('selected');
        selectedPot = { vid: p.vid, price: p.price, title: p.title };
        if (p.img) showComposite(p.img, p.title); else backTo360();
        updatePrice();
      });
      potRow.appendChild(b);
    });

    backTo360();
    updatePrice();
  }

  renderPots();

  /* Size change re-renders pots (per-size lists) and resets to "No pot". */
  if (sizeRow) {
    sizeRow.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-option-value]'); if (!btn) return;
      setTimeout(function () { renderPots(); }, 0);
    });
  }

  /* Add the selected pot alongside the plant. When no pot is chosen we do nothing
     and let the theme's default add-to-cart handler add the plant only. */
  if (form) {
    form.addEventListener('submit', function (e) {
      if (!selectedPot) return;
      e.preventDefault();
      e.stopImmediatePropagation(); /* prevent theme.js adding the plant separately */

      var plantId = variantInput ? variantInput.value : null;
      if (!plantId) { return; }

      var original = submitBtn ? submitBtn.textContent : '';
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Adding…'; }

      var body = { items: [
        { id: Number(plantId), quantity: 1 },
        { id: Number(selectedPot.vid), quantity: 1 }
      ] };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
        body: JSON.stringify(body),
        credentials: 'same-origin'
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () {
          if (window.Greenform && window.Greenform.refreshCart) return window.Greenform.refreshCart();
        })
        .then(function () {
          if (submitBtn) {
            submitBtn.textContent = 'Added ✓';
            setTimeout(function () { submitBtn.textContent = original; submitBtn.disabled = false; }, 1200);
          }
        })
        .catch(function () {
          if (submitBtn) { submitBtn.textContent = original; submitBtn.disabled = false; }
        });
    }, true); /* capture so we run before theme.js's document-level submit handler */
  }
})();
